import { create } from 'zustand';
import { createJSONStorage, devtools, persist, StateStorage } from 'zustand/middleware';

export type StorageType = 'local' | 'session' | 'none' | StateStorage;

export interface StoreOptions<T> {
  name: string;
  partialize?: (state: T) => Partial<T>;
  storage?: StorageType;
}

export function createCommonStore<T>(
  storeCreator: (set: (partial: Partial<T> | ((state: T) => Partial<T>)) => void) => T,
  options?: StoreOptions<T>,
) {
  return create<T>()(
    devtools(
      options?.name && options?.storage !== 'none'
        ? persist(storeCreator, {
            name: options.name,
            partialize: options.partialize || ((state) => state),
            storage: createJSONStorage(() => {
              if (!options.storage || options.storage === 'session') return sessionStorage;
              if (options.storage === 'local') return localStorage;
              return options.storage as StateStorage;
            }),
          })
        : storeCreator,
    ),
  );
}

export * from './use-header-store';
export * from './use-user-info-store';
export * from './use-filters-store';
